import { isAbsoluteUrl } from './is-absolute-url.js';
import { WIX_MEDIA_BASE_URL, WIX_VIDEO_BASE_URL } from './media-url-consts.js';

export const getAbsoluteUrl = (url: string, type: 'image' | 'video') => {
  if (isAbsoluteUrl(url)) {
    return url;
  }

  let baseUrl: string, baseFolder: string;
  if (type === 'image') {
    baseUrl = WIX_MEDIA_BASE_URL;
    baseFolder = 'media/';
  } else {
    //video
    baseUrl = WIX_VIDEO_BASE_URL;
    baseFolder = 'video/';
  }

  const pathWithFolder = url.startsWith(baseFolder) ? url : baseFolder + url;
  return baseUrl + pathWithFolder;
};
